let currentIndex = 1;
const container = document.getElementById("reviewContainer");
const reviews = Array.from(document.querySelectorAll(".review"));
const totalReviews = reviews.length;

// Clone first and last reviews for infinite loop
const firstClone = reviews[0].cloneNode(true);
const lastClone = reviews[totalReviews - 1].cloneNode(true);

// Add clone at the start and end
container.appendChild(firstClone);
container.insertBefore(lastClone, reviews[0]);

// Default transformation
container.style.transform = `translateX(-${currentIndex * 100}%)`;

function getVisibleReviews() {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 1024) {
    return 3; // Desktop: Show 3 reviews
  } else if (screenWidth >= 768) {
    return 2; // Tablet: Show 2 reviews
  } else {
    return 1; // Mobile: Show 1 review
  }
}

function updateSlider() {
  container.style.transition = "transform 0.5s ease-in-out";
  const visibleReviews = getVisibleReviews();
  container.style.transform = `translateX(-${currentIndex * (100 / visibleReviews)}%)`;
}

function nextReview() {
  const visibleReviews = getVisibleReviews();
  if (currentIndex >= totalReviews) {
    container.style.transition = "none";
    currentIndex = 0;
    container.style.transform = `translateX(0)`;
    setTimeout(() => {
      currentIndex++;
      updateSlider();
    }, 50);
  } else {
    currentIndex++;
    updateSlider();
  }
}

function prevReview() {
  const visibleReviews = getVisibleReviews();
  if (currentIndex <= 0) {
    container.style.transition = "none";
    currentIndex = totalReviews;
    container.style.transform = `translateX(-${currentIndex * (100 / visibleReviews)}%)`;
    setTimeout(() => {
      currentIndex--;
      updateSlider();
    }, 50);
  } else {
    currentIndex--;
    updateSlider();
  }
}

// Event Listeners for Buttons
document.querySelector(".prev").addEventListener("click", prevReview);
document.querySelector(".next").addEventListener("click", nextReview);

// Adjust on window resize
window.addEventListener("resize", updateSlider);

// Initialize
updateSlider();
